//
//
//
//
//
//
//
//

import CourseIntro from '@/components/course-intro.vue';
import Absolutebtn from '@/components/absolutebtn.vue';
// import { mapGetters, mapActions } from 'vuex';
// import api from '../../api/index';
export default {
  components: {
    CourseIntro,
    Absolutebtn
  },
  name: 'intro',
  data() {
    return {};
  },
  methods: {
    // ...mapActions()
  },
  watch: {},
  computed: {
    // ...mapGetters()
  },
  created() {},
  mounted() {
    let elem = document.querySelector('#vux_view_box_body');
    setTimeout(() => {
      elem.style.paddingBottom = '0';
    }, 10);
  }
};
